import { useState } from 'react';

function CarteRealisation({ image, tag, titre, description, client, clientLogo, clientUrl}) {
    return (
        <div className="flex flex-col bg-white dark:bg-bleu-gris rounded-[10px] shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300">

            {/* Image */}
            <div className="h-[180px] w-full overflow-hidden">
                {image && (
                    <img
                        src={image}
                        alt={titre}
                        className="w-full h-full object-cover"
                    />
                )}
            </div>

            {/* Contenu */}
            <div className="flex flex-col flex-1 p-5 gap-3">

                {/* Tag domaine */}
                <span className="text-bleu-je text-[12px] font-semibold uppercase tracking-wide">
                    {tag}
                </span>

                {/* Titre */}
                <h3 className="text-gris-sombre dark:text-blanc-sombre font-bold text-[16px] leading-snug">
                    {titre}
                </h3>

                {/* Description */}
                <p className="text-gris-sombre dark:text-gray-300 text-[13px] leading-relaxed flex-1">
                    {description}
                </p>

                {/* Client (optionnel) */}
                {client && (
                    <div className="flex items-center gap-3 pt-3 border-t border-gray-100 dark:border-gray-700 mt-auto">
                        {clientLogo && (
                            <img
                                src={clientLogo}
                                alt={client}
                                className="h-7 w-auto object-contain"
                            />
                        )}
                        <span className="text-gris-sombre dark:text-gray-300 text-[13px] font-semibold">
                            {client}
                        </span>
                        {clientUrl && (
                            <a
                                href={clientUrl}
                                target="_blank"
                                rel="noreferrer"
                                className="ml-auto text-bleu-je text-[12px] hover:underline"
                            >
                                {clientUrl}
                            </a>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

function GrilleRealisations({ realisations }) {
    if (!realisations || realisations.length === 0) return null;

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-14">
            {realisations.map((r, i) => (
                <CarteRealisation key={i} {...r} />
            ))}
        </div>
    );
}

export default GrilleRealisations;